<script>
    import {format, isBefore, isSameMonth, setDate} from 'date-fns';

    import Duracion from "../../../UI/Duracion.svelte";

    import store from '../../../../Stores/Trabajadores/ver-trabajador-store';
    import storeTipos from '../../../../Stores/tipos-de-jornada-store';

    let previstas, trabajadas, titulo, mes, dias, fecha, calendario, marcajes, tipos;

    const ahora = new Date();

    $: fecha = $store.fecha;
    $: if (!$store.marcajes.cargando && !$store.calendario.cargando && !$storeTipos.cargando) {
        mes = $store.mes;
        tipos = $storeTipos.listadoIndexado;
        dias = Object.keys(mes);

        previstas = dias
            .filter(x => !isSameMonth(fecha, ahora) || isBefore(setDate(fecha, x), ahora))
            .reduce((acc, dia) => acc + (mes[dia].duracion || 0), 0);

        marcajes = $store.marcajes.marcajes;

        trabajadas = Object.values(marcajes).filter(x => x.tiempoTotal).reduce((acc, x) => acc + parseFloat(x.tiempoTotal), 0);
    } else {
        previstas = trabajadas = 0;
    }

    titulo = isSameMonth(fecha, ahora) ? `Horas hasta el ${format(ahora, 'dd/MM/yyyy')}` : 'Horas';
</script>

<style>
    .resumen {
        margin: calc(var(--padding-global) / 2) 0 var(--padding-global);
        width: 15em;
        margin-left: auto;
        border: 1px solid var(--naranja-clarito);
        box-shadow: 0 6px 6px -6px rgba(0, 0, 0, .2);
        border-radius: var(--radio-global);
        padding: var(--padding-global);
        box-sizing: content-box;
    }

    tfoot {
        color: var(--acentos);
    }
</style>

<div class="resumen">
    <table>
        <thead>
        <th colspan="2">{titulo}</th>
        </thead>
        <tbody>
        <tr>
            <th>Previstas</th>
            <td>
                <Duracion minutos={previstas}/>
            </td>
        </tr>
        <tr>
            <th>Trabajadas</th>
            <td>
                <Duracion minutos={trabajadas}/>
            </td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
            <th>Diferencia</th>
            <td>
                <Duracion minutos={trabajadas - previstas}/>
            </td>
        </tr>
        </tfoot>
    </table>
</div>
